// extracted by mini-css-extract-plugin
module.exports = {"inlineLink":"InlineLink_inlineLink__2IOZK"};